import React, { useEffect, useState } from "react";
import AdminNavbar from "../components/AdminNavbar";
import AdminSidebar from "../components/AdminSidebar";
import { useSidebar } from "../components/SidebarContext";
import AdminStudentList from "../components/AdminStudentList";
import api from "../services/api"; 

export default function AdminCompletedTestsPage() {
  const { isSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? "15.6rem" : "4.4rem";
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompletedTests = async () => {
      try {
        const response = await api.get('/results/completed-tests');
        setStudents(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch test data");
      } finally {
        setLoading(false);
      }
    };

    fetchCompletedTests();
  }, []);

  return (
    <div style={styles.page}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100%",
          width: sidebarWidth,
          zIndex: 10,
          transition: "width 0.3s ease",
        }}
      >
        <AdminSidebar />
      </div>

      <div
        style={{
          marginLeft: sidebarWidth,
          marginTop: "55px",
          width: `calc(100% - ${sidebarWidth})`,
          transition: "all 0.3s ease",
        }}
      >
        <AdminNavbar />
        <div style={styles.container}>
          <h2 style={styles.header}>Students Who Attempted Tests</h2>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p style={{ color: "red" }}>{error}</p>
          ) : (
            <AdminStudentList students={students} />
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)",
    display: "flex",
  },
  container: {
    padding: "2rem",
  },
  header: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#1E3A8A",
    marginBottom: "1.5rem",
  },
};
